import { Route } from "@angular/router";

export const SubsidyPaths = {
  Overview: "overzicht",
};

export default [
  {
    path: SubsidyPaths.Overview,
    loadComponent: () =>
      import("./pages/subsidy-overview/subsidy-overview.component").then(
        (c) => c.SubsidyOverviewComponent
      ),
    data: {
      breadcrumb: "Subsidies",
      title: "Subsidies",
    },
  },
] satisfies Route[];
